export default {
  computed: {
    allInventoryType: function () {
      return this.$store.state.ActivityTypeStore.all_activity_types
    }
    // singleInventory: function () {
    //   var index = this.$route.params.inventory_id
    //   return this.$store.state.ActivityStore.activities[index]
    // }
  }
}
